/* global axios */
import ApiClient from '../ApiClient';

class ZaloPersonalChannel extends ApiClient {
  constructor() {
    super('callbacks', { accountScoped: true });
  }

  startQrSession(inboxName) {
    return axios.post(`${this.url}/zalo_personal_start_qr_session`, {
      inbox_name: inboxName,
    });
  }

  qrStatus(inboxId) {
    return axios.get(`${this.url}/zalo_personal_qr_status`, {
      params: { inbox_id: inboxId },
    });
  }

  connectionStatus(inboxId) {
    return axios.get(`${this.url}/zalo_personal_connection_status`, {
      params: { inbox_id: inboxId },
    });
  }

  restartQr(inboxId) {
    return axios.post(`${this.url}/zalo_personal_restart_qr`, {
      inbox_id: inboxId,
    });
  }

  resolveContact(inboxId, phone) {
    return axios.post(`${this.url}/zalo_personal_resolve_contact`, {
      inbox_id: inboxId,
      phone,
    });
  }

  startConversation(inboxId, payload) {
    return axios.post(`${this.url}/zalo_personal_start_conversation`, {
      inbox_id: inboxId,
      ...payload,
    });
  }
}

export default new ZaloPersonalChannel();
